import React, {useState, useEffect, useMemo} from 'react';
import { Button, Linking, RefreshControl, ScrollView, StyleSheet, TextInput, TouchableOpacity, View } from 'react-native'

import tw from '../../../styles/tailwind';
import Text from '../../../components/Text';
import IcomoonIcon from '../../../components/IcomoonIcon';
import { Icon } from '../../../components/Icon';
import { Illustration } from '../../../components/Illustration';
import ResidentsModal from './ResidentsModal';
import VehiclesModal, { vehicleColors } from './VehiclesModal';
import { SafeAreaView, useSafeAreaInsets } from 'react-native-safe-area-context';
import { Image } from 'expo-image';
import api from '../../../utils/api';
import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import useRegisterForPushNotifications from '../../../hooks/useRegisterPushNotifications';




function AnnouncementButton({ announcement, onPress }) {
  const dateStr = dayjs(announcement.created_at).format('DD/MMM/YYYY')

  const isNew = announcement.seen === false

  return (
    <TouchableOpacity style={tw`bg-white rounded-xl px-4 py-3 w-60`} onPress={onPress}>
      {
        isNew &&
          <Text style={tw`absolute right-3 -top-3 px-2 py-[0.5] bg-red-400 rounded-full text-white text-center`}>Nuevo</Text>
      }

      <Text style={tw`text-gray-400 mb-2`}>{dateStr}</Text>

      <Text style={tw`text-gray-800 leading-4 mb-2`} numberOfLines={2}>{announcement.title}</Text>
      <Text style={tw`text-gray-400 leading-4`} numberOfLines={3}>{announcement.text}</Text>
    </TouchableOpacity>
  )
}


function VehicleRow({ vehicle }) {
  const vehicleColor = vehicleColors.find(color => color.name == vehicle.color)

  return (
    <View style={tw`bg-gray-100 border border-gray-200 rounded-xl px-4 py-3 w-40`}>
      <View style={tw``}>
        <Text style={tw`text-gray-600`}>{vehicle.brand} {vehicle.model} {vehicle.year}</Text>
        <Text style={tw`text-gray-400`}>{vehicle.plate_number}</Text>
      </View>

      <View style={tw`row`}>
        {
          vehicleColor &&
            <View style={tw`h-4 w-4 border-gray-200 border rounded-full mr-2 bg-[${vehicleColor.hex}]`}></View>
        }
        <Text style={tw`text-gray-400 text-sm`}>{vehicle.color}</Text>
      </View>

    </View>
  )
}






import DocumentDetailModal from './Documents/DocumentDetailModal';


import { useNavigation } from '@react-navigation/core';
import IconButton from '../../../components/IconButton';
import useActiveResidentCommunity from '../../../hooks/useActiveResidentCommunity';
import CommunityUnitHeader from './components/CommunityUnitHeader';

import dayjs from 'dayjs';
import AcceptToSModal from './AcceptToSModal';
import useFormSubmit from '../../../hooks/useFormSubmit';
import { ResidentUnitFeeRow } from './Fees/UnitFeesScreen';





function VehiclesBlock({ vehicles, onBlockPress }){
  const hasVehicles = vehicles.length > 0

  return (
    <TouchableOpacity style={tw.style(`bg-white rounded-xl py-6`, hasVehicles && `py-4`)} onPress={onBlockPress}>
      <View style={tw.style(`row justify-between px-4`, hasVehicles && `mb-4`)}>
        <View style={tw`row`}>
          <View style={tw`w-12 items-center`}>
            <Illustration name="vehiculos" width={44} height={39} />
          </View>

          <View style={tw`ml-3 flex-1`}>
            <View style={tw`row`}>
              <Text style={tw`text-secondary font-500 text-lg`}>Mis vehículos</Text>
              <IcomoonIcon name='chevron-right' color={tw.color('secondary')} style={tw`ml-2 -mt-1`} />
            </View>
            <Text style={tw`text-gray-400 text-sm`}>Es importante para el acceso y la seguridad del fraccionamiento</Text>
          </View>
        </View>
      </View>

      <ScrollView horizontal contentContainerStyle={tw`gap-x-3 px-4`} showsHorizontalScrollIndicator={false}>
        {
          vehicles.map(vehicle =>
            <VehicleRow key={vehicle.uuid} vehicle={vehicle} />
          )
        }
      </ScrollView>
    </TouchableOpacity>
  )
}


function ResidentsBlock({ residents, onBlockPress }){
  const hasResidents = residents.length > 0

  return (
    <TouchableOpacity style={tw.style(`bg-white rounded-xl py-3`, hasResidents && `py-4`)} onPress={onBlockPress}>
      <View style={tw.style(`row justify-between px-4 py-2`, hasResidents && `mb-2`)}>
        <View style={tw`row`}>
          <View style={tw`w-12 items-center`}>
            <Illustration name="residentes" width={40} height={50} />
          </View>

          <View style={tw`ml-3 flex-1`}>
            <View style={tw`row`}>
              <Text style={tw`text-secondary font-500 text-lg `}>Residentes</Text>
              <IcomoonIcon name='chevron-right' color={tw.color('secondary')} style={tw`ml-2 -mt-1`} />
            </View>
            <Text style={tw`text-gray-400 text-sm`}>Personas con libre acceso al fraccionamiento</Text>
          </View>
        </View>
      </View>

      {
        hasResidents &&
          <View style={tw`bg-gray-100 mx-3 border border-gray-200 rounded-xl`}>
            {
              residents.map((resident, i) =>
                <View
                  key={resident.uuid}
                  style={tw.style(`border-b border-gray-200 px-5 py-3`, (i + 1) == residents.length && `border-b-0`) }>
                  <Text style={tw`text-base text-gray-600`}>{resident.name}</Text>
                </View>
              )
            }
          </View>
      }
    </TouchableOpacity>
  )
}



function TicketsBlock({ onPress, hasNewMessages }) {
  return (
    <TouchableOpacity onPress={onPress} style={tw`bg-white rounded-2xl px-4 py-4`}>
      <View style={tw`row`}>
        <View style={tw`w-12 items-center`}>
          <Illustration name="reportes" width={44} height={37} />
        </View>

        <View style={tw`ml-3 flex-1`}>
          <View style={tw`row`}>
            <Text style={tw`text-secondary font-500 text-lg`}>Reportes y solicitudes</Text>
            <IcomoonIcon name='chevron-right' color={tw.color('secondary')} style={tw`ml-2 -mt-1`} />
          </View>

          {
            hasNewMessages ?
              <View style={tw`row items-center mt-1`}>
                <View style={tw`w-2 h-2 rounded-full bg-red-500 mr-2`}></View>
                <Text style={tw`text-red-500 text-sm font-500`}>Tienes mensajes nuevos</Text>
              </View>
            :
              <Text style={tw`text-gray-400 text-sm`}>
                Reporta lo que necesite atención del administrador
              </Text>
          }
        </View>
      </View>
    </TouchableOpacity>
  );
}


function DocumentsBlock({documents}){
  const [selectedDocumentModal, setSelectedDocumentModal] = useState(null);

  return (
    <View style={tw`bg-white rounded-2xl py-4 px-4`}>
      <View style={tw`row mb-4`}>
        <Illustration name="reglamento" width={48} height={40} />

        <View style={tw`ml-3 flex-1`}>
          <Text style={tw`text-secondary text-xl font-600`}>Documentos</Text>
          <Text style={tw`text-gray-400`}>Archivos importantes que todos los residentes deben conocer.</Text>
        </View>
      </View>

      {
        documents?.map(doc =>
          <TouchableOpacity
            key={doc.uuid}
            style={tw`row items-center bg-gray-50 border border-gray-200 rounded-xl px-3 py-3 mb-2`}
            onPress={() => setSelectedDocumentModal(doc)}
          >
            <Illustration name="pdfIcon" width={28} height={28} style={tw`mr-3`} />

            <Text style={tw`text-gray-500 flex-1`} numberOfLines={1}>{doc.name}</Text>
          </TouchableOpacity>
        )
      }

      {
        (documents.length == 0) &&
          <Text style={tw`text-gray-300 text-center py-4`}>Sin documentos</Text>
      }

      {
        selectedDocumentModal &&
          <DocumentDetailModal
            document={selectedDocumentModal}
            onRequestClose={() => setSelectedDocumentModal(null)}
          />
      }
    </View>
  )
}


function DashboardHeader({ dashboardData }){
  const { user } = useSelector(state => state.status)

  return (
    <View style={tw`mb-6 pt-10`}>
      <Text style={tw`text-3xl text-white mb-3`}>¡Hola {user.name?.split(" ")[0]}!</Text>

      <CommunityUnitHeader community={dashboardData.community} unit={dashboardData.unit} />
    </View>
  )
}



function MyFeesSection({ fees, unitId }){
  const navigation = useNavigation()

  const filteredFees = useMemo(() => {
    return fees.items.filter(fee => {
      const apply_month = dayjs(fee.apply_month)

      // Solo muestra los que no están pagados o que sea de mes current
      return ! fee.is_paid || apply_month.isSame(new Date, 'month')
    })
  }, [fees?.items])

  
  const pendingFeesCount = useMemo(() => {
    return filteredFees.filter(fee => {
    
      return ! fee.is_paid 
    }).length
  }, [filteredFees])

  return (
    <View style={tw`bg-gray-100 rounded-2xl px-4 py-4 mb-6 gap-y-4`}>
      <View style={tw`row`}>
        <Icon name="finanzas" size={40} />

        <View style={tw`ml-4`}>
          <Text style={tw`text-lg text-secondary font-500`}>Mis cuotas</Text>
          <Text style={tw`-mt-2 text-gray-400`}>{pendingFeesCount == 0 ? "Sin" : pendingFeesCount} cuota{pendingFeesCount != 1 && 's'} pendientes</Text>
        </View>
      </View>

      <View style={tw`bg-white rounded-xl shadow-sm`}>
        {
          filteredFees?.map(unit_fee =>
            <ResidentUnitFeeRow unitId={unitId} key={unit_fee.uuid} unitFee={unit_fee} />
          )
        }
      </View>


      <TouchableOpacity
        style={tw`row items-center bg-secondary-400  px-5 py-4 rounded-2xl`}
        onPress={() => navigation.navigate('Resident.Fees', { unitId })}
      >
        <Icon name="historialPagos" size={32} />

        <Text style={tw`text-white ml-3 flex-1`}>Historial de {"\n"}pagos</Text>

        {/* <Icon name='chevron-right' color={tw.color('white')} style={tw`ml-2 -mt-1`} /> */}
        <Icon name="rightArrowCircle" size={16} color="#f1dffb" />
      </TouchableOpacity>
    </View>
  )
}






export default function ResidentDashboardScreen({navigation}) {
  const [showResidentsModal, setShowResidentsModal] = useState(false);
  const [showVehiclesModal, setShowVehiclesModal] = useState(false);

  const insets = useSafeAreaInsets();

  const { community, communityId } = useActiveResidentCommunity()
  const auth = useSelector((state) => state.auth);

  // const selectedCommunity = communities?.[0]//! TOFIX!!
  // const communityId = selectedCommunity?.uuid


  const { isLoading, error, data, refetch } = useQuery({
    queryKey: ['resident.community.dashboard', communityId, auth.user.email],
    queryFn: () => api.get(`/communities/${communityId}/resident/dashboard`).then(response => response.data),
    enabled: false,
  })


  console.log(">>>>>>>>", { communityId, isLoading, error})


  // Effect para refrescar cada que se haga focus en el tab
  React.useEffect(() => {
    const unsubscribe = navigation.addListener('focus', () => {
      refetch()
    });

    return unsubscribe;
  }, [navigation]);


  React.useEffect(() => {
    if (communityId){
      refetch()
    }
  }, [communityId]);


  // Se repite en
  const { registerPushToken } = useRegisterForPushNotifications()

  useEffect(() => {
    registerPushToken()
  }, []);


  if (isLoading || ! data) return <Text style={tw`text-lg text-gray-600 mt-40 text-center`}>Cargando...</Text>

  if (error) return <View style={tw`flex-1 justify-center items-center px-8`}>
    <Text>Ocurrió un error</Text>
    <Text style={tw`text-gray-400`}>{error?.message}</Text>
    <IconButton title={"Intentar de nuevo"} onPress={refetch} />
  </View>

  return (
    <ScrollView
      style={tw``}
      contentContainerStyle={tw`pb-24 bg-gray-200`}
      keyboardShouldPersistTaps='handled'
      refreshControl={
        <RefreshControl onRefresh={refetch} refreshing={isLoading} />
      }
    >
      <View style={tw.style(`bg-secondary rounded-b-2xl px-4 pb-4`, { paddingTop: insets .top})}>
        {/* Header */}
        <DashboardHeader dashboardData={data} />


        {/* Cuotas */}
        {
          (data.settings?.fees_enabled && data.fees?.items?.length) > 0 &&
            <MyFeesSection fees={data.fees} unitId={data.unit.uuid} />
        }{/* Cuotas */}




        {/* Avisos y comunicados */}
        {
          (() => {
            const all = data.announcements ?? []
            if (all.length === 0) return null

            const unread = all.filter(a => a.seen === false)
            const hasUnread = unread.length > 0

            // Si hay sin leer: mostrar todos los no leídos + "Ver todos".
            // Si ya leyó todos: mostrar solo el último publicado + "Ver más".
            const itemsToShow = hasUnread ? unread : [all[0]]
            const buttonLabel = 'Ver\nTodos'

            return (
              <View style={tw`-mx-4`}>
                <View style={tw`row px-4`}>
                  <Icon name="navComunicados" variant="white" size={34} style={tw`mr-3`} />

                  <View style={tw``}>
                    <Text style={tw`text-white text-lg`}>Avisos y comunicados</Text>
                    {
                      hasUnread &&
                        <Text style={tw`text-white/70 -mt-0.5`}>{unread.length} sin leer</Text>
                    }
                  </View>
                </View>

                <ScrollView horizontal contentContainerStyle={tw`gap-x-4 px-4 pt-5 items-stretch`} showsHorizontalScrollIndicator={false}>
                  {
                    itemsToShow.map(announcement =>
                      <AnnouncementButton
                        key={announcement.uuid}
                        announcement={announcement}
                        onPress={() => navigation.navigate("Resident.Announcement.Detail", { announcementId: announcement.uuid })}
                      />
                    )
                  }

                  <TouchableOpacity
                    style={tw`bg-white/10 rounded-xl w-24 items-center justify-center px-2`}
                    onPress={() => navigation.navigate('Resident.Announcements.Index')}
                  >
                    <Text style={tw`text-white font-400 text-center leading-5`}>{buttonLabel}</Text>
                  </TouchableOpacity>
                </ScrollView>
              </View>
            )
          })()
        }
      </View>



      <View style={tw`px-4 pt-4`}>

        {/* Incidencias */}
        {
          data?.settings?.can_create_tickets === true &&
            <View style={tw`mb-4`}>
              <TicketsBlock
                onPress={() => navigation.navigate('Resident.Tickets.Index')}
                hasNewMessages={!!data?.has_new_ticket_messages}
              />
            </View>
        }


        {/* Residentes */}
        <View style={tw`mb-4`}>
          <ResidentsBlock residents={data.residents} onBlockPress={() => setShowResidentsModal(true)} />
        </View>


        {/* Mis vehiculos */}
        <View style={tw`mb-4`}>
          <VehiclesBlock vehicles={data.vehicles} onBlockPress={() => setShowVehiclesModal(true)} />
        </View>


        {/* Documents */}
        <View style={tw`mb-4`}>
          <DocumentsBlock documents={data.documents} />
        </View>
      </View>


      <ResidentsModal
        communityId={communityId}
        residents={data.residents}
        unitId={data?.unit.uuid}
        visible={showResidentsModal}
        onRequestClose={() => setShowResidentsModal(false)}
        onResidentCreated={() => {
          // setShowResidentsModal(false)
          refetch()
        }}
        onResidentDeleted={() => {
          refetch()
        }}
      />

      <VehiclesModal
        vehicles={data.vehicles}
        communityId={communityId}
        unitId={data?.unit.uuid}
        visible={showVehiclesModal}
        onRequestClose={() => setShowVehiclesModal(false)}
        onVehicleCreated={() => {
          setShowVehiclesModal(false)
          refetch()
        }}
        onVehicleDeleted={() => {
          refetch()
        }}
      />

      {
        data.community.should_accept_tos == true &&
          <AcceptToSModal
            onToSAccepted={refetch}
          />
      }
    </ScrollView>
  );
}
